export const EDUCATION_STAGES = ["ประถมต้น", "ประถมปลาย", "ม.ปลาย", "ม.ต้น"];
